module.exports = __webpack_public_path__ + "static/media/piper-rocket-bg-pink.14b0a8b9.svg";